import { Button } from '@baseball-near-you/ui';

export function NoTeamsMessage(props: {
  onAddTeam: () => void;
}) {
  return (
    <div className="mt-8 flex w-full flex-col items-center rounded-sm border border-gray-200 bg-gray-100 py-6">
      <p className="font-medium text-base text-gray-600">
        Can't find your team in our system?
      </p>
      <Button
        className="mt-4 bg-red text-white"
        onClick={() => {
          props.onAddTeam();
        }}
      >
        add a new team organization
      </Button>
    </div>
  );
}
